module.exports = __webpack_public_path__ + "img/CF_2X.2.0429ecc6.jpg";